import { useEffect } from 'react'

import { PAGES_CACHE } from '../utils/navigation'

import { useRouter } from './useRouter'

export const usePreload = () => {
  const router = useRouter()

  useEffect(() => {
    if (!PAGES_CACHE.length) return

    // Find the index of the current page
    const currentIndex = PAGES_CACHE.findIndex((route) =>
      route.path.includes(router.resolvedPathname)
    )

    const next = PAGES_CACHE[Math.min(currentIndex + 1, PAGES_CACHE.length - 1)]

    // Preload the next page
    void router.prefetch(next.path)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.resolvedPathname])
}
